import { Link } from 'react-router-dom';
import '../App.css';
import Header from '../components/Header';
import { Helmet } from 'react-helmet-async';

function CareSuitesEnquiry() {
  return (
    <>
      <Helmet>
        <title>Care Suites Enquiry | Whitstable House</title>
        <meta
          name="description"
          content="Enquire about Whitstable House Care Suites for long-term nursing, dementia and continuing care needs, with 24-hour clinical support."
        />
        <link rel="canonical" href="https://www.whitstable.house/CareSuitesEnquiry" />
      </Helmet>

      <div className="page">
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
        <Header />

        <main id="main-content">
          <section className="content-section care-suites-enquiry-page">
            <div className="care-suites-enquiry-container">
              <h1>Care Suites Enquiry</h1>

              <div className="contact-layout care-suites-enquiry-layout">
                <div className="care-suites-enquiry-content">
                  <section className="care-suites-enquiry-block">
                    <h2>Who are the Care Suites suitable for?</h2>
                    <p>
                      Our Care Suites are designed for individuals who require ongoing nursing care, dementia
                      support, or a longer-term care solution beyond rehabilitation. This may include people living
                      with complex health conditions, reduced mobility, memory loss, or those needing 24-hour
                      clinical oversight and support with daily living.
                    </p>
                    <p>
                      Unlike our{' '}
                      <Link to="/rehab" className="nurse-care-link">
                        Rehabilitation Centre
                      </Link>
                      , which focuses on short-term recovery and regaining independence following illness, injury
                      and surgery, the Care Suites provide a more permanent and supportive living environment for
                      those with continuing care needs.
                    </p>
                    <p>
                      Each private suite includes a kitchenette, dining area, en-suite bathroom and comfortable
                      lounge space, creating a homely and dignified setting for residents and their families.
                      Suites are available through a range of{' '}
                      <Link to="/self-funding" className="nurse-care-link">
                        funding pathways
                      </Link>
                      .
                    </p>
                    <p>
                      With Registered Nurses on-site 24 hours a day, 7 days a week, alongside innovative wellbeing
                      technology — including vital signs monitoring, fall prevention systems and sleep quality
                      tracking — our Care Suites provide a holistic approach to supporting the health, safety and
                      wellbeing of your loved one.
                    </p>
                    <img
                      src="/whitstable-suite-main-room.jpg"
                      alt="Care suite main room at Whitstable House"
                      className="care-suites-enquiry-block__image"
                    />
                  </section>
                </div>

                <div className="contact-right-column">
                  <section className="contact-section-main">
                    <h2>
                      For more information or to ask any questions you might have, please phone, email or write to
                      us.
                    </h2>

                    <div className="contact-details">
                      <div className="contact-address">
                        <p>Whitstable House</p>
                        <p>Boorman Way</p>
                        <p>Whitstable</p>
                        <p>Kent</p>
                        <p>CT5 3SE</p>
                      </div>

                      <div className="contact-info">
                        <p>
                          <strong>Tel:</strong>{' '}
                          <a href="tel:01227533522">01227 533522</a>
                        </p>
                        <p>
                          <strong>Enquiries:</strong>{' '}
                          <a href="mailto:enquiries@whitstable.house">enquiries@whitstable.house</a>
                        </p>
                      </div>
                    </div>
                  </section>

                  <section className="find-us-section">
                    <h2>Find Us</h2>
                    <p>
                      Whitstable House overlooks the Thames Estuary and is within easy reach of Estuary View Medical
                      Centre.
                    </p>

                    <div className="map-container">
                      <iframe
                        src="https://www.google.com/maps?q=Whitstable+House,+Boorman+Way,+Whitstable+CT5+3SE&output=embed"
                        width="100%"
                        height="450"
                        style={{ border: 0 }}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Whitstable House Location"
                        className="google-map-iframe"
                      />
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </section>
        </main>

        <footer className="footer">
          <section className="footer__enquiry">
            <div className="footer__enquiry-container">
              <Link to="/contact-us" className="footer__enquiry-link">
                Enquire about Whitstable House <span className="footer__arrow">▶</span>
              </Link>
            </div>
          </section>
          <div className="footer__container">
            <section className="contact-section">
              <div className="contact-section__content">
                <p>Whitstable House, Boorman Way, Whitstable CT5 3SE</p>
                <p>Copyright © Whitstable House</p>
              </div>
            </section>
          </div>
        </footer>
      </div>
    </>
  );
}

export default CareSuitesEnquiry;
